// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.multiselect[data-v-64eef6b7] {\n\twidth: 100%;\n\tmargin: auto;\n\ttext-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
